import { IsNotEmpty, IsInt, IsOptional, IsISO8601 } from 'class-validator';

export class AbilityEditDTO {

    @IsNotEmpty()
    @IsInt()
    abilityType: number;

    @IsOptional()
    @IsISO8601()
    from: string;

    @IsOptional()
    @IsISO8601()
    to: string;

}
